import React, { FC, ReactNode, useRef } from 'react';

import Icon from '../icons';

import styles from './simple-accordion.module.css';

type SimpleAccordionPropsType = {
  onChange?(id: string): void;
  opened: boolean;
  label?: string | ReactNode;
  additionalLabelClassNames?: string;
  children: ReactNode;
  id: string;
  dataId?: string;
  arrowClassName?: string;
  summaryClassName?: string;
};

const SimpleAccordion: FC<SimpleAccordionPropsType> = (props) => {
  const {
    onChange,
    opened,
    additionalLabelClassNames,
    label,
    children,
    dataId,
    id,
    summaryClassName,
    arrowClassName,
  } = props;
  const containerRef = useRef<HTMLDetailsElement>(null);

  function handleCHangeEvent(event: React.MouseEvent<HTMLDetailsElement>) {
    event.preventDefault();
    event.stopPropagation();
    let targetElement = event.target as HTMLElement;

    while (targetElement && targetElement !== containerRef.current) {
      if (targetElement.classList.contains('danger')) {
        return;
      }
      targetElement = targetElement.parentElement as HTMLElement;
    }
    onChange?.(id);
  }

  return (
    <details ref={containerRef} data-id={dataId} open={opened} className={styles.details}>
      <summary onClick={handleCHangeEvent} className={`mb-[18px] ${summaryClassName}`}>
        <div
          className={`cursor-pointer flex items-center gap-[10px] text-[16px] font-[400] leading-[187%] tracking-[-0.03em] text-0color`}
        >
          <div
            className={`${
              opened ? 'rotate-90' : '-rotate-90'
            } w-[24px] justify-center transition-all flex items-center`}
          >
            <Icon
              size={9}
              name="ChevronLeftV2Icon"
              className={`${arrowClassName || ''} text-action `}
            />
          </div>
          {label && (
            <span className={`${additionalLabelClassNames} font-bold text-[24px] w-full`}>
              {label}
            </span>
          )}
        </div>
      </summary>
      <div>{children}</div>
    </details>
  );
};

export default SimpleAccordion;
